import { Nullable } from '@shared/models/types';

export class QuequeMgr<T> {
  private readonly items: T[] = [];
  private readonly processingFunction: (item: T) => void;
  private timer: Nullable<ReturnType<typeof setInterval>>;
  private processingInterval: number; // 1 minuto di default

  constructor(processingFunction: (item: T) => void, interval = 60000) {
    this.processingFunction = processingFunction;
    this.processingInterval = interval; // 1 minuto in millisecondi
  }

  // Aggiunge un elemento alla coda e avvia il timer se non è già attivo
  public enqueue(element: T): void {
    this.items.push(element);
    if (this.timer == null) {
      this.startProcessing();
    }
  }

  // Cambia l'intervallo di elaborazione (in millisecondi)
  public setProcessingInterval(interval: number): void {
    this.processingInterval = interval;

    // Se il timer è attivo, riavvialo con il nuovo intervallo
    if (this.timer != null) {
      this.stopProcessing();
      this.startProcessing();
    }
  }

  // Rimuove l'elemento all'inizio della coda e lo restituisce
  private dequeue(): Nullable<T> {
    if (this.isEmpty()) {
      return null;
    }
    return this.items.shift();
  }

  // Verifica se la coda è vuota
  private isEmpty(): boolean {
    return this.items.length === 0;
  }

  // Avvia il timer per elaborare gli elementi
  private startProcessing(): void {
    this.timer = setInterval(() => {
      if (!this.isEmpty()) {
        const item = this.dequeue();
        if (item) {
          this.processingFunction(item);
        }
      } else {
        // Ferma il timer se non ci sono elementi
        this.stopProcessing();
      }
    }, this.processingInterval);
  }

  // Interrompe il timer
  private stopProcessing(): void {
    if (this.timer != null) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
